// shared/pdf/components/PdfFooter.jsx
import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 40,
    right: 40,
  },
  rule:   { borderTopWidth: 0.5, paddingTop: 5 },
  row:    { flexDirection: 'row', justifyContent: 'space-between' },
  text:   { fontSize: 7, fontFamily: 'NotoSans' },
  bar:    { height: 3, marginTop: 6, borderRadius: 2 },
});

export default function PdfFooter({ theme }) {
  return (
    <View style={styles.footer} fixed>
      <View style={[styles.rule, { borderTopColor: theme.rule || theme.mid }]}>
        <View style={styles.row}>
          <Text style={[styles.text, { color: theme.muted }]}>Generated by Jainam Seva Setu  |  Confidential</Text>
          <Text style={[styles.text, { color: theme.muted }]} render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          } />
        </View>
      </View>
      <View style={[styles.bar, { backgroundColor: theme.primary }]} />
    </View>
  );
}
